import React, { useState, useEffect, useCallback } from "react";
import { authCarouselSlides } from "_constants";
import {
  StyledCarouselWrapper,
  StyledCarouselBg,
  StyledCarouselBgImage,
  StyledCarouselContent,
  StyledCarouselHeadline,
  StyledCarouselSubtitle,
  StyledCarouselDots,
  StyledCarouselDot,
} from "./index.styled";

const SLIDE_INTERVAL = 5000;

const AuthCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const goToSlide = useCallback((index) => {
    setActiveIndex(index);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % authCarouselSlides.length);
    }, SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, []);

  const currentSlide = authCarouselSlides[activeIndex];

  return (
    <StyledCarouselWrapper>
      {authCarouselSlides.map((slide, index) => (
        <StyledCarouselBgImage
          key={index}
          $active={index === activeIndex}
          style={{ backgroundImage: `url(${slide.background})` }}
        />
      ))}
      <StyledCarouselBg />

      <StyledCarouselContent>
        <StyledCarouselHeadline key={activeIndex}>
          {currentSlide.headline}
        </StyledCarouselHeadline>
        <StyledCarouselSubtitle>
          {currentSlide.subtitle}
        </StyledCarouselSubtitle>
        <StyledCarouselDots>
          {authCarouselSlides.map((_, index) => (
            <StyledCarouselDot
              key={index}
              $active={index === activeIndex}
              onClick={() => goToSlide(index)}
            />
          ))}
        </StyledCarouselDots>
      </StyledCarouselContent>
    </StyledCarouselWrapper>
  );
};

export default AuthCarousel;
